var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var Forms = /** @class */ (function (_super) {
    __extends(Forms, _super);
    function Forms() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Forms.prototype.passwordChangeFormLite = function (id, disabled) {
        if (disabled === void 0) { disabled = false; }
        var dstring = disabled ? "disabled" : "";
        return "<div class=\"mb-3\"><input oncopy=\"return false\" name=\"firstpassword\" class=\"form-control password\" type=\"text\" id=\"".concat(id, "_password\" ").concat(dstring, " /></div><div class=\"mb-3\"><input oncopy=\"return false\" name=\"secondpassword\" class=\"form-control password\" type=\"text\" id=\"").concat(id, "_confirm\" ").concat(dstring, " /></div><div class=\"mb-3\"><button id=\"").concat(id, "_savebtn\" class=\"btn btn-primary w-100px me-5px\" disabled>Speichern</button></div>");
    };
    Forms.prototype.onPasswordInputChange = function (id) {
        var enSaveBtn = function () {
            var v1 = $("#".concat(id, "_password")).val();
            var v2 = $("#".concat(id, "_confirm")).val();
            if (v1 != "" && v2 != "" && v1 == v2) {
                $("#".concat(id, "_savebtn")).removeAttr('disabled');
            }
            else {
                $("#".concat(id, "_savebtn")).attr('disabled', "true");
            }
        };
        $("#".concat(id, "_password")).on('keyup', function () { return enSaveBtn(); });
        $("#".concat(id, "_confirm")).on('keyup', function () { return enSaveBtn(); });
    };
    Forms.prototype.totpInputs = function () {
        return "<div class=\"totpinput mb-20px\">\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"1\" />\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"2\" />\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"3\" />\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"4\" />\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"5\" />\n                <input type=\"number\" class=\"form-control fs-15px\" data-totp-input=\"6\" />\n            </div>";
    };
    Forms.prototype.totpListenEvent = function (fn) {
        $('[data-totp-input]').on('focus', function (elm) {
            var target = $(elm.currentTarget);
            if (target.data('totp-input') == "1") {
                $('[data-totp-input="1"]').val('');
                $('[data-totp-input="2"]').val('');
                $('[data-totp-input="3"]').val('');
                $('[data-totp-input="4"]').val('');
                $('[data-totp-input="5"]').val('');
                $('[data-totp-input="6"]').val('');
            }
            //if (target.val() != "") target.val("")
        });
        $('[data-totp-input]').on('input', function (elm) {
            var target = $(elm.currentTarget);
            var index = parseInt($(elm.currentTarget).data('totpInput'));
            var next = index + 1;
            if (target.val() > 9)
                target.val(9);
            target.val(Math.abs(target.val()));
            if (next <= 6) {
                $('[data-totp-input="' + next + '"]').trigger('focus');
            }
            else {
                var v1 = $('[data-totp-input="1"]').val().toString();
                var v2 = $('[data-totp-input="2"]').val().toString();
                var v3 = $('[data-totp-input="3"]').val().toString();
                var v4 = $('[data-totp-input="4"]').val().toString();
                var v5 = $('[data-totp-input="5"]').val().toString();
                var v6 = $('[data-totp-input="6"]').val().toString();
                if (v1 != "" && v2 != "" && v3 != "" && v4 != "" && v5 != "" && v6 != "") {
                    fn(v1 + v2 + v3 + v4 + v5 + v6);
                }
            }
        });
    };
    Forms.prototype.createFloatingInputs = function (items) {
        var html = "";
        items.forEach(function (item) {
            if (item.length >= 3) {
                if (typeof item[2] == "object") {
                    if (item[2].type == "select") {
                        var options_1 = "";
                        item[2].data.forEach(function (opt) {
                            options_1 += "<option value=\"".concat(opt[1], "\">").concat(opt[0], "</option>");
                        });
                        html += "<div class=\"form-floating mb-3\"><select class=\"form-select fs-15px\" id=\"".concat(item[0], "\">").concat(options_1, "</select><label for=\"").concat(item[0], "\" class=\"d-flex align-items-center fs-13px\">").concat(item[1], "</label></div>");
                    }
                }
                else {
                    if (item[2].toLowerCase() == "button") {
                        html += "<div class=\"mb-3\"><button id=\"".concat(item[0], "\" class=\"btn btn-primary w-100\" >").concat(item[1], "</button></div>");
                    }
                    else {
                        html += "<div class=\"form-floating mb-3\"><input type=\"".concat(item[2], "\" class=\"form-control fs-15px\" id=\"").concat(item[0], "\" placeholder=\"").concat(item[1], "\" /><label for=\"").concat(item[0], "\" class=\"d-flex align-items-center fs-13px\">").concat(item[1], "</label></div>");
                    }
                }
            }
        });
        return html;
    };
    return Forms;
}(Gadget));
export { Forms };
